export var PropertyBuildingHeadingEnum;
(function (PropertyBuildingHeadingEnum) {
    PropertyBuildingHeadingEnum["Floor"] = "Floor";
    PropertyBuildingHeadingEnum["ExistingSize"] = "Existing Size";
    PropertyBuildingHeadingEnum["AddedSize"] = "Added Size";
    PropertyBuildingHeadingEnum["BuildingNameNumber"] = "Building name / number";
})(PropertyBuildingHeadingEnum || (PropertyBuildingHeadingEnum = {}));
export const PropertyBuildingHeadingEnumHeadingLookup = new Map([
    [PropertyBuildingHeadingEnum.Floor, "floor"],
    [PropertyBuildingHeadingEnum.ExistingSize, "existingSize"],
    [PropertyBuildingHeadingEnum.AddedSize, "addedSize"],
    [PropertyBuildingHeadingEnum.BuildingNameNumber, "buildingNameNumber"]
]);
